import { FormGroupDefinition } from "../../Components/FormGroup";
import { basic_number_validator, basic_text_validator, boolean_selection_validator, date_validator, email_validator, multiselect_validator, phone_validator, selection_validator, url_validator } from "../formFieldValidators";
import { addressFormDefinition } from "./founderProfileBase";

export const updatedFounderProfileEvaluationFormGroupDefinition: FormGroupDefinition = {
  /* Contact Information */
  personalInfo: {
    sectionLabel: "Personal Information",
    frSectionLabel: "Renseignements personnels",
    formDefinition: {
      firstName: {
        frLabel: "Prénom",
        label: "First Name",
        inputType: "text",
        validator: basic_text_validator,
      },
      lastName: {
        frLabel: "Nom de famille",
        label: "Last Name",
        inputType: "text",
        validator: basic_text_validator,
      },
      // [TODO] handle conditional checkboxes and other field feature
      pronouns: {
        frLabel: "Vos pronoms",
        label: "Your Pronouns",
        inputType: "customMultiSelectNarrow",
        validator: multiselect_validator,
        additionalData: {
          selectionData: [
            {
              text: "she/her",
              frText: "elle",
              value: "she"
            },
            {
              text: "he/him",
              frText: "il",
              value: "he"
            },
            {
              text: "they/them",
              frText: "eux",
              value: "they"
            },
            {
              text: "prefer not to say",
              frText: "préfère ne pas répondre",
              value: "notToSay"
            },
          ]
        }
      },
      title: {
        frLabel: "Titre du poste",
        label: "Job Title",
        inputType: "text",
        validator: basic_text_validator,
      },
      phoneNumber: {
        frLabel: "No de téléphone",
        label: "Phone Number",
        inputType: "text",
        validator: phone_validator,
      },
      isPointOfContact: {
        label: "I'm the point of contact",
        frLabel: "Je suis la personne-ressource",
        inputType: "checkbox",
        tooltip: {
          content: "If you would prefer email notification and communication from EIP to go to another point of contact, please leave this checkbox unselected and specify the prefered point of contact below",
          position: "bottom-right"
        },
        frTooltip: {
          content: "Si vous préférez que les avis par courriel et les communications d'ÉleverlaPI soient envoyés à une autre personne-ressource, veuillez ne pas cocher cette case et préciser la personne-ressource souhaitée ci-dessous",
          position: "bottom-right"
        }
      }
    }
  },
  pointOfContact: {
    conditionalRenderDefinition: {
      fieldKey: "isPointOfContact",
      renderWhenTrue: false, 
    },
    sectionLabel: "Point of Contact",
    frSectionLabel: "Personne-ressource",
    formDefinition: {
      firstName: {
        frLabel: "Prénom",
        label: "First Name",
        inputType: "text",
        validator: basic_text_validator,
      },
      lastName: {
        frLabel: "Nom de famille",
        label: "Last Name",
        inputType: "text",
        validator: basic_text_validator,
      },
      // [TODO] pronouns is waiting on conditional checkboxes feature
      title: {
        frLabel: "Titre du poste",
        label: "Job Title",
        inputType: "text",
        validator: basic_text_validator,
      },
      email: {
        frLabel: "Courriel",
        label: "Email",
        inputType: "text",
        validator: email_validator,
      },
      phoneNumber: {
        frLabel: "No de téléphone",
        label: "Phone Number",
        inputType: "text",
        validator: phone_validator,
      },
      // [TODO] roleTags is waiting on conditional checkboxes feature
    }
  },
  /* Company Information */
  basicInfo: {
    sectionLabel: "Company Information",
    frSectionLabel: "Renseignements sur l'entreprise",
    formDefinition: {
      operatingName: {
        frLabel: "Nom commercial",
        label: "Operating Name",
        inputType: "text",
        validator: basic_text_validator,
      },
      // isLegalNameSameAsOperatingName: {
      //   frLabel: "Le nom légal de notre entreprise est le même que son nom commercial. Le nom légal complet doit être fourni.",
      //   label: "Our company's legal name is the same as its operating name.  Full legal name must be provided.",
      //   inputType: "checkbox",
      // },
      legalName: {
        // conditionalRenderDefinition: {
        //   fieldKey: "isLegalNameSameAsOperatingName",
        //   renderWhenTrue: false, 
        // },
        label: "Legal Name",
        frLabel: "Nom légal",
        inputType: "text",
        validator: basic_text_validator,
      },
      description: {
        label: "Company Description",
        frLabel: "Description de l’entreprise",
        inputType: "textarea",
        validator: basic_text_validator,
      },
      industry: {
        label: "Industry",
        frLabel: "Industrie",
        inputType: "dropdownSelect",
        tooltip: {
          content: "Click on the field and select an option from the list.",
          position: "bottom-right"
        },
        frTooltip: {
          content: "Cliquez sur le champ et sélectionnez une option dans la liste.",
          position: "bottom-right"
        },
        validator: selection_validator,
        additionalData: {
          selectionData: [
            {
              value: "Agriculture",
              text: "Agriculture",
              frText: "Agriculture",
            },
            {
              value: "Advanced Materials & Manufacturing: Excludes specifically forestry, agriculture, mining, clean technologies and life sciences",
              text: "Advanced Materials & Manufacturing: Excludes specifically forestry, agriculture, mining, clean technologies and life sciences",
              frText: "Matériaux d’avant-garde et fabrication Exclut spécifiquement la sylviculture, l'agriculture, l'exploitation minière, les technologies propres et les sciences de la vie.",
            },
            {
              value: "Clean Tech: Technologies that protect and/or increase efficient utilization of land, water and air resources",
              text: "Clean Tech: Technologies that protect and/or increase efficient utilization of land, water and air resources",
              frText: "Tech. propres : technologies qui protègent et/ou augmentent l’utilisation efficace des ressources de la terre, de l'eau et de l’air",
            },
            {
              value: "Consumer Retail",
              text: "Consumer Retail",
              frText: "Consommation de détail",
            },
            {
              value: "Digital Media & Telecommunications: Digital applications and content and information and communications technologies. Excludes healthcare, agriculture, forestry, mining, financial services, education, social innovation, culture/recreation and energy-related solutions",
              text: "Digital Media & Telecommunications: Digital applications and content and information and communications technologies. Excludes healthcare, agriculture, forestry, mining, financial services, education, social innovation, culture/recreation and energy-related solutions",
              frText: "Médias numériques et télécommunications Applications numériques et technologies de l’information et de communication Exclut les soins de santé, l'agriculture, la sylviculture, l'exploitation minière, les services financiers, l'éducation, l'innovation sociale, la culture et loisirs, et les solutions liées à l'énergie.",
            },
            {
              value: "Education",
              text: "Education",
              frText: "Éducation",
            },
            {
              value: "Financial Services",
              text: "Financial Services",
              frText: "Services financiers",
            },
            {
              value: "Food & Beverage",
              text: "Food & Beverage",
              frText: "Restauration/production d’aliments et boissons",
            },
            {
              value: "Forestry",
              text: "Forestry",
              frText: "Foresterie",
            },
            {
              value: "Life Sciences & Health",
              text: "Life Sciences & Health",
              frText: "Sciences de la vie et de la santé",
            },
            {
              value: "Mining, Oil & Gas: Includes extractive activities that would not otherwise fall under clean technologies",
              text: "Mining, Oil & Gas: Includes extractive activities that would not otherwise fall under clean technologies",
              frText: "Exploitation minière, pétrole et gaz : Comprend les activités d’extraction qui ne relèveraient pas autrement des technologies propres",
            },
            {
              value: "Tourism & Culture: Includes entertainment and sports",
              text: "Tourism & Culture: Includes entertainment and sports",
              frText: "Culture et tourisme : comprend le divertissement et le sport",
            },
            {
              value: "Transportation",
              text: "Transportation",
              frText: "Transport",
            },
            {
              value: "Other",
              text: "Other",
              frText: "Autre",
            }
          ]
        }
      },
      websiteURL: {
        label: "Website URL",
        frLabel: "URL du site Web",
        inputType: "text",
        validator: url_validator,
      },
    }
  },
  registration: {
    sectionLabel: "Registration Information",
    frSectionLabel: "Enregistrement de l’entreprise",
    formDefinition: {
      number: {
        label:  `The business number (BN), assigned to all incorporated businesses by the Canada Revenue Agency, is a 9-digit number that is unique to a business or legal entity. (Note: the BN is followed by a two-letter program identifier and a 4-digit reference number, both of which are unnecessary for this application). This number is different from the 7-digit Corporation Number and should not contain a hyphen.  If a valid 9-digit BN is not provided, the application will be rejected as it is a requirement for participation in ElevateIP.  For more details on what a BN is, visit (<a target='_blank' href='https://www.canada.ca/en/revenue-agency/services/tax/businesses/topics/registering-your-business/you-need-a-business-number-a-program-account.html'>this website</a>)",`,
        frLabel:  `Le numéro d’entreprise (NE) est un numéro à 9 chiffres attribué à toutes les entreprises constituées en société par l’Agence du revenu du Canada. Détenir un numéro d’enregistrement est une condition pour participer à ÉleverlaPI. Pour plus d’informations sur les numéros d’entreprise, (<a target='_blank' href='https://www.canada.ca/en/revenue-agency/services/tax/businesses/topics/registering-your-business/you-need-a-business-number-a-program-account.html'> cliquez ici.</a>)",`,
        inputType: "text",
        validator: {
          ...basic_number_validator,
          minLength: {
            value: 9,
            message: "Registration number must be nine digits",
            frMessage: "Le numéro d'enregistrement doit comporter neuf chiffres",
          },
          maxLength: {
            value: 9,
            message: "Registration number must be nine digits",
            frMessage: "Le numéro d'enregistrement doit comporter neuf chiffres",
          }
        }
      },
      date: {
        label: "Registration Date",
        frLabel: "Date de l’enregistrement",
        inputType: "date",
        validator: date_validator,
      },
      province: {
        label: "Registered Provinces and Territories",
        inputType: "multiSelectNarrow",
        frLabel: "Provinces et territoires enregistrés",
        validator: multiselect_validator,
        additionalData: {
          selectionData: [
            {
              value: "AB",
              text: "Alberta",
              frText: "Alberta",
            },
            {
              value: "BC",
              text: "British Columbia",
              frText: "Colombie-Britannique",
            },
            {
              value: "MB",
              text: "Manitoba",
              frText: "Manitoba",
            },
            {
              value: "NB",
              text: "New Brunswick",
              frText: "Nouveau-Brunswick",
            },
            {
              value: "NL",
              text: "Newfoundland and Labrador",
              frText: "Terre-Neuve-et-Labrador",
            },
            {
              value: "NT",
              text: "Northwest Territories",
              frText: "Territoires du Nord-Ouest",
            },
            {
              value: "NS",
              text: "Nova Scotia",
              frText: "Nouvelle-Écosse",
            },
            {
              value: "NU",
              text: "Nunavut",
              frText: "Nunavut",
            },
            {
              value: "ON",
              text: "Ontario",
              frText: "Ontario",
            },
            {
              value: "PE",
              text: "Prince Edward Island",
              frText: "Île-du-Prince-Édouard",
            },
            {
              value: "QC",
              text: "Quebec",
              frText: "Québec",
            },
            {
              value: "SK",
              text: "Saskatchewan",
              frText: "Saskatchewan",
            },
            {
              value: "YT",
              text: "Yukon",
              frText: "Yukon",
            },
          ]
        }
      }
    }
  },
  mailingAddress: {
    sectionLabel: "Mailing Address",
    frSectionLabel: "Adresse postale",
    formDefinition: addressFormDefinition,
  },
  programingEvaluation: {
    sectionLabel: "Service Evaluation",
    frSectionLabel: "Évaluation du service",
    formDefinition: {
      hasSocialOrEnvironmentalGoals: {
        label: "Does your company have social or environmental goals as part of its founding mission?",
        frLabel: "Un des fondements et objectifs de votre entreprise est pour un bénéfice à la société ou à l’environnement?",
        inputType: "boolean",
      },
      numFullTimeEmployees: {
        label: "Number of Full Time Employees",
        frLabel: "Nombre d'employés à temps plein",
        inputType: "number",
        validator: basic_number_validator,
      },
      isProductForSaleOnMarket: {
        frLabel: "Le produit que vous cherchez à protéger est-il actuellement en vente sur le marché?",
        label: "Is the product you are looking to protect currently for sale on the market?",
        inputType: "boolean"
      },
      productForSaleInfo: {
        conditionalRenderDefinition: {
          fieldKey: "isProductForSaleOnMarket",
          renderWhenTrue: true, 
        },
        label: "Please select all that apply",
        frLabel: "Veuillez sélectionner tous les énoncés qui s'appliquent",
        inputType: "multiSelect",
        validator: multiselect_validator,
        additionalData: {
          selectionData: [
            {
              value: "singleProduct",
              text: "The product I want to protect is currently for sale",
              frText: "Le produit que je veux protéger est actuellement en vente",
            },
            {
              value: "multipleProducts",
              text: "There are multiple products I want to protect that are currently for sale",
              frText: "Plusieurs produits que je veux protéger sont actuellement en vente",
            },
          ]
        }
      },
      revenueOverTwelveMonths: {
        label: "Indicate your company’s total revenue (in $CAD) during your most recent fiscal year.",
        frLabel: "Indiquez le revenu total de votre entreprise (en $ CA) au cours de votre dernier exercice financier.",
        inputType: "number",
        validator: basic_number_validator,
      },
      // coPayEligible: {
      //     label: "Eligible for 10% Co-investment",
      //     frLabel: "",
      //     inputType: "boolean",
      //   },
      isFromOLMC: {
        label: "Are you from an official language minority community (<a target='_blank' href='https://www.canada.ca/en/treasury-board-secretariat/services/values-ethics/official-languages/public-services/official-language-minority-communities.html'>OLMC</a>)?",
        frLabel: "Êtes-vous issu(e) d'une communauté de langue officielle en situation minoritaire (<a target='_blank' href='https://www.canada.ca/en/treasury-board-secretariat/services/values-ethics/official-languages/public-services/official-language-minority-communities.html'>CLOSM</a>)?",
        inputType: "boolean"
      },
      officialLanguageMinorityCommunity: {
        conditionalRenderDefinition: {
          fieldKey: "isFromOLMC",
          renderWhenTrue: true,
        },
        label: "Which OLMC are you a part of?",
        frLabel: "De quelle CLOSM faites-vous partie?",
        inputType: "customDropdownSelect",
        // tooltip: {
        //   content:  "Click on the field and select an option from the list or Enter your own directly.",
        //   position: "top-left"
        // },
        // frTooltip: {
        //   content:  "",
        //   position: "top-left"
        // },
        validator: selection_validator,
        additionalData: {
          selectionData: [
            {
              value: "ACF",
              text: "Assemblée communautaire fransaskoise (ACF)",
              frText: "Assemblée communautaire fransaskoise (ACF)",
            },
            {
              value: "AFO",
              text: "Assemblée de la francophonie de l'Ontario (AFO)",
              frText: "Assemblée de la francophonie de l'Ontario (AFO)",
            },

            {
              value: "FCFA",
              text: "Fédération des communautés francophones et acadienne du Canada (FCFA)",
              frText: "Fédération des communautés francophones et acadienne du Canada (FCFA)",
            },
            {
              value: "SFM",
              text: "Société franco-manitobaine (SFM)",
              frText: "Société franco-manitobaine (SFM)",
            },
            {
              value: "SNA",
              text: "Société nationale de l'Acadie (SNA)",
              frText: "Société nationale de l'Acadie (SNA)",
            },
          ]
        }
      },
      additionalLinks: {
        label: "Please Provide Any Additional Supporting Links (Pitch Deck, Business Plan, etc)",
        frLabel: "Veuillez fournir tout autre lien à l'appui (présentation aux investisseurs, plan d'affaires, etc.)",
        inputType: "text",
        validator: url_validator,
      },
    }
  },
  iPStrategy: {
    sectionLabel: "IP Readiness",
    frSectionLabel: "Préparation à la PI",
    formDefinition: {
      bestMatch: {
        frLabel: "Lequel des énoncés suivants correspond le mieux à vos besoins actuels?",
        label: "Which of the following best match your needs at this time?",        inputType: "multiSelect",
        validator: multiselect_validator,
        additionalData: {
          selectionData: [
            {
              value: "education",
              text: "I’m seeking general IP Education (e.g. Where do I start? What is a patent?, etc.)",
              frText: "Je recherche une formation générale en PI (p. ex., par où dois-je commencer? Qu'est-ce qu'un brevet?, etc.).",
            },
            {
              value: "strategy",
              text: "I’m seeking support for IP Strategy Development (e.g, What/how/when/where should I protect? I need help with patentability/novelty searches., etc.)",
              frText: "Je recherche de l'aide pour l'élaboration d'une stratégie de PI (p. ex., quoi/comment/quand/où dois-je protéger? J'ai besoin d'aide pour des recherches de brevetabilité/nouveauté, etc.).",
            },
            {
              value: "trademarks",
              text: "I think I’m ready to register trademarks in the next 3-6 months",
              frText: "Je pense que je suis prêt(e) à enregistrer des marques dans les 3 à 6 prochains mois.",
            },
            {
              value: "patents",
              text: "I think I’m ready to file patents in the next 3-6 months or convert PCT / provisional or continuations",
              frText: "Je pense que je suis prêt(e) à déposer des brevets dans les 3 à 6 prochains mois ou à convertir un PCT, à déposer une demande de brevet provisoire ou à reconduire un brevet",
            },
          ]
        }
      },
      assignmentAgreement: {
        frLabel: "Vos cofondateurs et vous avez-vous signé une « entente de cession de la PI entre cofondateurs » qui cède la PI à la société?",
        label: 'Have you and your cofounders signed a "Co-founders IP assignment agreement" that assigns IP to the corporation? ',
        inputType: "boolean",
        validator: boolean_selection_validator
      },
      patentsReadyOptions: {
        frLabel: "Si vous pensez être prêt(e) à déposer des brevets dans les 3 à 6 prochains mois, veuillez indiquer lesquels des énoncés suivants s'appliquent à la technologie que vous comptez breveter :",
        label: " If you think you are ready to file patents in the next 3-6 months, please indicate which of the following apply to the technology you intend to patent:",
        inputType: "multiSelect",
        validator: multiselect_validator,
        additionalData: {
          selectionData: [
            {
              value: "notApplicable",
              text: "Not applicable, as I am not seeking support to file patents in the next 3-6 months",
              frText: "Sans objet, car je ne cherche pas d'aide pour déposer des brevets dans les 3 à 6 prochains mois",
            },
            {
              value: "search",
              text: "My IP service provider has conducted a favorable patentability/prior art/novelty search for the technology I plan to patent.",
              frText: "Mon fournisseur de services en PI a effectué une recherche de brevetabilité/d'art antérieur/de nouveauté favorable pour la technologie que je compte breveter.",
            },
            {
              value: "family",
              text: "I have a granted patent in the same patent family.",
              frText: "J'ai un brevet délivré dans la même famille de brevets.",
            },
            {
              value: "written",
              text: "I have received a favorable written opinion from my PCT application.",
              frText: "J'ai reçu une opinion écrite favorable dans le cadre de ma demande PCT.",
            },
            {
              value: "support",
              text: "I don’t have B or C or D and I am seeking support to file patent",
              frText: "Je n'ai pas B, C ou D et je cherche de l'aide pour déposer un brevet",
            },
          ]
        }
      },
      trademarkClearanceSearch: {
        frLabel: "Si vous pensez être prêt(e) à enregistrer des marques de commerce dans les 3 à 6 prochains mois, votre fournisseur de services en PI a-t-il effectué une recherche de disponibilité?",
        label: "If you think you are ready to register trademarks in the next 3-6 months, has your IP service provider completed a clearance search?",
        inputType: "boolean",
        validator: boolean_selection_validator
      },
      isWorkingWithLawFirm: {
        frLabel: "Votre entreprise est présentement en contact avec une firme d’avocats et de PI",
        label: "Is your company currently working with an IP / Law firm?",
        inputType: "boolean",
      },
      workingLawFirms: {
        conditionalRenderDefinition: {
          fieldKey: "isWorkingWithLawFirm",
          renderWhenTrue: true,
        },
        frLabel: "Veuillez indiquer le nom des firmes",
        label: "Please list the name of firms",
        inputType: "customList",
      },
      isWorkingWithBai: {
        frLabel: "Votre entreprise travaille-t-elle actuellement avec un autre IAA (Incubateur Accélérateur d’Affaires)?",
        label: "Is your company currently working with a different BAI?",
        inputType: "boolean",
      },
      otherBai: {
        conditionalRenderDefinition: {
          fieldKey: "isWorkingWithBai",
          renderWhenTrue: true,
        },
        frLabel: "Veuillez indiquer quelle organisation",
        label: "Please specify which organization",
        inputType: "text",
        validator: basic_text_validator
      }
    }
  }
}






